import { JSX } from 'react';
import { Link, LinkProps } from 'react-router-dom';

function EmptyStateButton({
  onClick,
  label,
  icon,
  description,
}: {
  onClick: () => void;
  label: string;
  description?: string;
  icon: JSX.Element;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-neutral-300 bg-neutral-50 p-8 hover:border-neutral-400 focus:ring-2 focus:ring-corso-blue-600 focus:ring-offset-2 focus:outline-hidden"
    >
      <span className="text-neutral-500 *:h-12 *:w-12">{icon}</span>
      <span className="text-sm font-semibold text-neutral-800">{label}</span>
      {description && (
        <span className="text-left text-sm text-neutral-500">
          {description}
        </span>
      )}
    </button>
  );
}

function EmptyStateLink({
  to,
  label,
  icon,
  description,
}: {
  to: LinkProps['to'];
  label: string;
  description?: string;
  icon: JSX.Element;
}) {
  return (
    <Link
      to={to}
      className="flex w-full flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-neutral-300 bg-neutral-50 p-8 hover:border-neutral-400 focus:ring-2 focus:ring-corso-blue-600 focus:ring-offset-2 focus:outline-hidden"
    >
      <span className="text-neutral-500 *:h-12 *:w-12">{icon}</span>
      <span className="text-sm font-semibold text-neutral-800">{label}</span>
      {description && (
        <span className="text-left text-sm text-neutral-500">
          {description}
        </span>
      )}
    </Link>
  );
}

export default {
  Button: EmptyStateButton,
  Link: EmptyStateLink,
};
